<template>
  <div class="mt-suggestion">
    <EditableLabel
      ref="editableLabel"
      v-model="value.text"
      class="no-bold"
      :legend="dtFormatted"
      :placeholder="$t('message.SUGGESTION')"
      generic-border
      @click.native="$refs.editableLabel.doFocus()"
      @input="textEdited"
    />
  </div>
</template>

<script>
import EditableLabel from '@/components/editable-label.vue';

export default {

  name: 'MtSuggestion',

  components: {
    EditableLabel,
  },

  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  computed: {
    dtFormatted() {
      const m = this.$moment(this.value.created);
      return m.isValid() ? m.format(this.$t('dateTimeFormat')) : '';
    },
  },

  methods: {
    textEdited() {
      this.$emit('suggestionChange', this.value);
    },
  },

};
</script>

<style lang="scss">
.mt-suggestion {
  margin-top: .7rem;
}
</style>
